export const CHECK_ADMIN_LOGIN = 'check_admin_login';
export const CHECK_STAFF_LOGIN = 'check_staff_login';
export const CHECK_LOGIN = 'check_login';
export const LOGIN_USER_SUCCESSFUL = 'login_user_successfull';
export const LOAD_USER = 'load_user';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const API_ERROR = 'api_failed';
export const LOAD_USER_SUCCESSFUL = 'load_user_successfull';
